import { FC } from "react";
import { Namespace, useDateFnsLocale, useT } from "@racoon/i18n";
import { Label } from "@racoon/ui";
import { formatContractDay } from "../model/contract-label";
import { FIELD_LABEL, readonlyBox, type FieldSize } from "./customer-bin-row";

/** «Период [start] - [end]» — the contract's span as read-only boxes. */
export const ContractPeriod: FC<{ startAt?: unknown; endAt?: unknown; size?: FieldSize }> = ({
  startAt,
  endAt,
  size,
}) => {
  const t = useT();
  const locale = useDateFnsLocale();

  return (
    <div className="flex items-center gap-4">
      <Label className={FIELD_LABEL}>{t(Namespace.PickupLocation, "modal.period")}</Label>
      <div className="flex items-center gap-2">
        <span className={readonlyBox(size)}>
          {formatContractDay(startAt, locale) ?? t(Namespace.PickupLocation, "modal.start")}
        </span>
        <span className={FIELD_LABEL}>-</span>
        <span className={readonlyBox(size)}>
          {formatContractDay(endAt, locale) ?? t(Namespace.PickupLocation, "modal.end")}
        </span>
      </div>
    </div>
  );
};
